import { AppLink } from "../components/app-link.js";
import { PageState } from "../components/page-state.js";
import { PATHS } from "../lib/routes.js";

/**
 * An address that matches no screen.
 *
 * Said rather than absorbed. The old fallback rendered Captures for every typo
 * and every stale link, so a wrong address looked like a working screen — the
 * same class of quiet wrong answer AGENTS.md §1 exists to stop. It names the
 * address, because "not found" alone leaves the reader to wonder whether they
 * lost something; the address is usually the answer.
 */
export function NotFoundScreen({ path }: { readonly path: string }) {
  return (
    <PageState
      title="There is no page here"
      actions={
        <AppLink href={PATHS.overview} className="button-primary">
          Go to Overview
        </AppLink>
      }
    >
      <p>
        Nothing in Crux lives at <code>{path}</code>. The link may be old or mistyped —
        your reports and questions are where they were.
      </p>
    </PageState>
  );
}
